<template>
    <div class="text-center px-1" :class="customClass">
        <p class="lead py-1 mb-0">
            <strong v-html="title" />
        </p>
    </div>
</template>
<script>
export default {
    name: "Banner",
    props: {
        title: {
            type: String,
            required: true
        },
        customClass: {
            type: String,
            default: "bg-info-subtle"
        }
    },
}
</script>
